import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ButtonWithBG from "../../../Components/UI/ButtonMain";
import moment from "moment";
import PrintingHeader from "../../../Components/Functionality/KirtiRoadline/PrintingHeader";
import {
  TabletheadRedLastStyle,
  TabletheadRedStyle,
  TabletheadStyle,
} from "../../../Utils/TableStyling";
import PrintingFooter from "../../../Components/Functionality/KirtiRoadline/PrintingFooter";
import PDFHeader from "../../../Components/Functionality/KirtiRoadline/PDFHeader";
import PDFFooter from "../../../Components/Functionality/KirtiRoadline/PDFFooter";
import { CompanyBillingLayout } from "../../../Layouts/pdfLayout/CompanyBillingLayout";
import { BillingHeader } from "../../../Layouts/pdfLayout/BillingHeaderLayout";
import { billingPayment } from "../../../Layouts/pdfLayout/BillingPaymentLayout";
import { BillingFooter } from "../../../Layouts/pdfLayout/BillingFooterLayout";
import * as pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { font } from "../../../Utils/PTSerif-Regular";
import { robotoBlack } from "../../../Utils/Roboto-Black";
import { PTSerifBold } from "../../../Utils/PTSerif-Bold";
import { background } from "../../../Layouts/pdfLayout/BackgroundLayout";
import { WE_USING_PAYPHONE } from "../../../Utils/Constants";
import { NotoSansDevanagariBold } from "../../../Utils/NotoSansDevanagari-Bold";
import { NotoSansDevanagariRegular } from "../../../Utils/NotoSansDevanagari-Regular";
const pdfMakeX = require("pdfmake/build/pdfmake.js");
const pdfFontsX = require("pdfmake-unicode/dist/pdfmake-unicode.js");
pdfMakeX.vfs = pdfFontsX.pdfMake.vfs;
//importing the fonts whichever present inside vfs_fonts file
//Making use of all the fonts defined
pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.pdfMake.vfs["PTSerif-Regular.ttf"] = font;
window.pdfMake.vfs["PTSerif-Bold.ttf"] = PTSerifBold;
window.pdfMake.vfs["Roboto-Black.ttf"] = robotoBlack;
window.pdfMake.vfs["NotoSansDevanagari-Bold.ttf"] = NotoSansDevanagariBold;
window.pdfMake.vfs["NotoSansDevanagari-Regular.ttf"] =
  NotoSansDevanagariRegular;
const CompanyInvoiceDownloadView = (props) => {
  const location = useLocation();
  let componentRef = useRef(); // eslint-disable-next-line
  const pageStyle = `@page {
    size: A4;
    margin: 10pt;
  }
  @media print {
    .pagebreak { page-break-before: always; } /* page-break-after works, as well */
}
  }`;
  useEffect(() => {
    // console.log(props, "print");
  }, [props]);

  // Download pdf
  const sanitizeFilename = (filename) => {
    // Replace special characters with underscores
    // Download pdf
      let checkNull = filename.includes("null");
      if (checkNull) {
        return filename.replace(/[^\w\s]/gi, "_")?.replace("null", "");
      } else if (!checkNull) {
        return filename.replace(/[^\w\s]/gi, "_");
    };
  };

  async function handleDownloadPdf(action ) {
    props.setIsLoading(true);

    //Specifying the fonts which we are going to use in our PDF
    pdfMake.fonts = {
      Roboto: {
        normal: "Roboto-Regular.ttf",
        bold: "Roboto-Black.ttf",
        italics: "Roboto-Italic.ttf",
        bolditalics: "Roboto-Italic.ttf",
      },
      PTSerifRegular: {
        normal: "PTSerif-Regular.ttf",
        bold: "PTSerif-Bold.ttf",
        italics: "PTSerif-Regular.ttf",
        bolditalics: "PTSerif-Regular.ttf",
      },
      NotoSansDevanagari: {
        normal: "NotoSansDevanagari-Regular.ttf",
        bold: "NotoSansDevanagari-Bold.ttf",
        italics: "NotoSansDevanagari-Regular.ttf",
        bolditalics: "NotoSansDevanagari-Regular.ttf",
      },
    };

    const invoicedata = props.data;
    const bankBranch = props.bankBranch;
    const profileData = props.profileData;
    const secondaryPhoneNo = props.secondaryPhoneNo;

    const contentRender = async () => {
      try {
        const BillingHeaderContent = await BillingHeader(
          profileData,
          secondaryPhoneNo,
          "billing",
          !props.noHeader
        );

        const BillingContent = await CompanyBillingLayout(
          invoicedata,
          WE_USING_PAYPHONE,
          bankBranch,
          profileData
        );

        const BillingPayment = await billingPayment(
          invoicedata,
          WE_USING_PAYPHONE,
          bankBranch,
          props.freight,
          props.noBalance
        );

        const BillingFooterContent = await BillingFooter("billing");

        return [
          BillingHeaderContent,
          BillingContent,
          { stack: [BillingPayment, BillingFooterContent], unbreakable: true },
        ];
      } catch (error) {
        // Handle errors if necessary
        console.error("Error in contentRender:", error);
        throw error; // Re-throw the error to propagate it
      }
    };

    const sanitizedFilename = sanitizeFilename(
      "Invoice of " + (props?.data?.invoiceNo || props?.data?.bookingInvoiceNo)
        ? props?.data?.invoiceNo
          ? props?.data?.invoiceNo
          : props?.data?.bookingInvoiceNo
          ? props?.data?.bookingInvoiceNo
          : "--"
        : props.invoiceNo
        ? props.invoiceNo
        : "--"
    );

    const fileName = `${sanitizedFilename}.pdf`;

    const pdfDocDefinition = {
      pageMargins: [35, 35, 35, 30],
      content: await contentRender().then((result) => result),
      info: { title: fileName },
      styles: {
        table: {
          margin: [0, 0, 0, 0], // Adjust the top margin of the entire table
        },
        tableHeader: {
          fontSize: 9,
          alignment: "start", // 'start' aligns text to the start of the cell
          bold: true,
          fillColor: "#fff",
          color: "#000",
          margin: [0, 0, 0, 0], // Adjust the margin for each header cell
          borderBottom: "1px solid #28328c",
        },
        cellStyle: {
          fontSize: 8,
          alignment: "center", // 'start' aligns text to the start of the cell
          fillColor: "#fff",
          color: "#000",
          margin: [0, 0, 0, 0], // Adjust the margin for each header cell
        },
      },
      background: props.showBorder ? background : () => {},
    };

    const callbackFunction = function () {
      // Here implement function for hide waiting loader
      props.setIsLoading(false);
    };
    const handlePrint = () => {
      pdfDocGenerator.print();
      props.setIsLoading(false);
    };

    const newLocal = pdfMake.createPdf(pdfDocDefinition);
    const pdfDocGenerator = newLocal;
    // pdfDocGenerator.open()
    action === "download"
    ? pdfDocGenerator.download(fileName, callbackFunction)
    : handlePrint();

  }
  return (
    <>
      {props?.data && (
        <div className="hidden">
          <div ref={componentRef}>
            <div
              className={`${
                props.showBorder &&
                ` border-double  border-4 ${
                  props.blackWhite ? "border-black" : "border-red-200"
                } `
              }    align-top m-5 text-center `}
              // style={{
              //   backgroundImage: "url(" + logo_oposity + ")",
              // }}
            >
              {props.mobilePrint ? (
                <PDFHeader
                  data={props?.data}
                  profileData={props?.profileData}
                  secondaryPhoneNo={props?.secondaryPhoneNo}
                  companyName={props?.data?.companyDetails?.name}
                  companyAdd={props?.data?.companyDetails?.billToAddress}
                  companyGst={props?.data?.companyDetails?.gst}
                  border={props.showBorder}
                  blackWhite={props.blackWhite}
                  mobilePrint={props.mobilePrint}
                />
              ) : (
                <PrintingHeader
                  data={props?.data}
                  profileData={props?.profileData}
                  secondaryPhoneNo={props?.secondaryPhoneNo}
                  companyName={props?.data?.companyDetails?.name}
                  companyAdd={props?.data?.companyDetails?.billToAddress}
                  companyGst={props?.data?.companyDetails?.gst}
                  border={props.showBorder}
                  blackWhite={props.blackWhite}
                />
              )}

              {/* Table start*/}
              <div
                style={{ minHeight: "280px" }}
                className="p-2 w-full mb-2 border-t-0 border-neutral-900 text-center"
              >
                <table className=" border-spacing-y-2 border-separate w-full border-neutral-900 text-xs font-sans text-center">
                  {/* header */}
                  <thead
                    style={{
                      maxHeight: "5px",
                      minHeight: "5px",
                      verticalAlign: "center",
                    }}
                    className="mb-2 text-center"
                  >
                    <tr className=" border-neutral-900 text-white text-center">
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadStyle(props.blackWhite)}  ${
                          props.mobilePrint && "pb-4"
                        } `}
                      >
                        Loading
                        <br />
                        Date
                      </th>
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadStyle(props.blackWhite)}  ${
                          props.mobilePrint && "pb-4"
                        } `}
                      >
                        From
                      </th>
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadStyle(props.blackWhite)}  ${
                          props.mobilePrint && "pb-4"
                        } `}
                      >
                        To
                      </th>
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadStyle(props.blackWhite)}  ${
                          props.mobilePrint && "pb-4"
                        } `}
                      >
                        Freight
                      </th>
                      {/* <th className="bg-primary-kirtiroadways border-neutral-900">
                        Advance
                      </th> */}
                      {/* <th
                        style={{ maxHeight: "5px" }}
                        className="bg-primary-kirtiroadways border-neutral-900"
                      >
                        Balance
                      </th> */}
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadRedStyle(props.blackWhite)}  ${
                          props.mobilePrint && "pb-4"
                        } `}
                      >
                        Hamali
                      </th>
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadRedStyle(props.blackWhite)}  ${
                          props.mobilePrint && "pb-4"
                        } `}
                      >
                        Detention
                      </th>
                      <th
                        style={{
                          maxHeight: "8px",
                          minHeight: "8px",
                          verticalAlign: "middle",
                        }}
                        className={`${TabletheadRedLastStyle(
                          props.blackWhite
                        )}  ${props.mobilePrint && "pb-4"} `}
                      >
                        Extra Charge
                      </th>
                      {/* <th
                        style={{ maxHeight: "5px" }}
                        className="bg-primary-kirtiroadways border-neutral-900 pr-2"
                      >
                        Total
                      </th> */}
                    </tr>
                  </thead>
                  {/* Rows map function */}
                  <tbody className="align-top font-bold text-center bg-bottom bg-no-repeat bg-[length:80%_90%]">
                    {props?.data?.booking.map((data, i) => (
                      <tr height="20px" className="border-neutral-900 " key={i}>
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-28 border-r-2`}
                        >
                          <span className="mt-2">
                            {moment(data?.loadingDate).format("DD-MM-YYYY")}
                          </span>
                        </td>
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-32 border-r-2`}
                        >
                          <span className="mt-2">
                            {data?.from?.toUpperCase()}
                          </span>
                        </td>
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-32 border-r-2`}
                        >
                          <span className="mt-2">{data?.to?.toUpperCase()}</span>
                        </td>
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-28 border-r-2`}
                        >
                          <span className="ml-2 mt-2 text-center">
                            {data?.freigth ? data?.freigth : 0}
                          </span>
                        </td>
                        {/* <td
                          height="20px"
                          className="border-r-2 border-gray-300 w-28"
                        >
                          <span className="mt-2 text-center">
                            {data?.advance
                              ? data?.advance
                              : 0}
                          </span>
                        </td> */}
                        {/* <td
                          height="20px"
                          className=" w-28"
                        >
                          <span className="mt-2 text-center">
                            {" "}
                            {data?.balance
                              ? data?.balance
                              : 0}
                          </span>
                        </td> */}
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-28 border-r-2`}
                        >
                          <span className="mt-2 text-center">
                            {data?.hamali ? data?.hamali : 0}
                          </span>
                        </td>
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-28 border-r-2`}
                        >
                          <span className="mt-2 text-center">
                            {data?.detention ? data?.detention : 0}
                          </span>
                        </td>
                        <td
                          height="20px"
                          className={` ${
                            props.blackWhite
                              ? "border-black"
                              : "border-gray-300"
                          }   items-center  w-28 `}
                        >
                          <span className="mt-2 text-center">
                            {data?.extraCharge ? data?.extraCharge : 0}
                          </span>
                        </td>
                        {/* <td height="20px" className=" w-28 mr-2">
                          <span className="mt-2 text-center">
                            {data?.total
                              ? data?.total
                              : 0}
                          </span>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Total Calculation */}
              {/* <table className="  w-full font-bold   font-sans">
                <thead style={{ maxHeight: "5px" }}>
                  <tr height="20px" className="border-neutral-900 ">
                    <td height="20px" className="w-20"></td>
                    <td height="20px" className="w-20"></td>
                    <td height="20px" className="w-20"></td>
                    <td height="20px" className="w-24"></td>
                    <td height="20px" className="w-24"></td>

                    <td height="20px" className="w-24">
                      <h1 className="font-bold  text-center text-white bg-primary-kirtiroadways py-1">
                        Total
                      </h1>
                    </td>
                    <td height="20px" className="w-24">
                      <h1 className="text-center font-bold text-white bg-primary-kirtiroadways py-1">
                        {props?.data?.totalBookingAmount
                          ? props?.data?.totalBookingAmount
                          : 0}
                      </h1>
                    </td>
                    <td height="20px" className="w-24">
                      <h1 className="text-center font-bold text-white bg-primary-kirtiroadways py-1">
                        {props?.data?.totalHamali
                          ? props?.data?.totalHamali
                          : 0}
                      </h1>
                    </td>
                    <td height="20px" className="w-24">
                      <h1 className="text-center font-bold text-white bg-primary-kirtiroadways py-1">
                        {props?.data?.totalDetention
                          ? props?.data?.totalDetention
                          : 0}
                      </h1>
                    </td>
                    <td height="20px" className="w-24">
                      <h1 className="text-center font-bold text-white bg-primary-kirtiroadways py-1">
                        {props?.data?.totalExtraCharge
                          ? props?.data?.totalExtraCharge
                          : 0}
                      </h1>
                    </td>
                    <td height="20px" className="w-24">
                      <h1 className="text-center font-bold text-white bg-primary-kirtiroadways py-1">
                        {props?.data?.grandTotal ? props?.data?.grandTotal : 0}
                      </h1>
                    </td>
                  </tr>
                </thead>
              </table> */}

              {/* Bannk Detail Start */}
              {props.mobilePrint ? (
                <PDFFooter
                  bankBranch={props.bankBranch}
                  Dropdown={props.Dropdown}
                  showBorder={props.showBorder}
                  blackWhite={props.blackWhite}
                  data={location?.data}
                  profileData={props.profileData}
                  totalInwords={location?.data?.grandTotalInWords}
                  noBalance={props.noBalance}
                  fright={props.fright}
                  optionsBank={props.optionsBank}
                  mobilePrint={props.mobilePrint}
                />
              ) : (
                <PrintingFooter
                  bankBranch={props.bankBranch}
                  Dropdown={props.Dropdown}
                  showBorder={props.showBorder}
                  blackWhite={props.blackWhite}
                  data={location?.data}
                  profileData={props.profileData}
                  totalInwords={location?.data?.grandTotalInWords}
                  noBalance={props.noBalance}
                  fright={props.fright}
                  optionsBank={props.optionsBank}
                />
              )}

              {/* Note */}
              {/* <div className="flex border-black border-b-2 flex-row mt-5 justify-between items-start m-2 font-sans text-sm">
                <div className="text-left flex flex-col w-1/2 ">
                  {props?.note && (
                    <p className="border-black border-x-2 border-t-2 p-2">
                      {props?.note}
                    </p>
                  )}
                </div>
                <div className="text-center">{KIRTIROADLINES}</div>
                <div className="text-right  font-bold ">
                  <h5>{AuthorizedSignatory}</h5>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      )}
      {/* printing */}
      <div className="mb-5 flex flex-row justify-center space-x-5 mt-10">
        {/* <ReactToPrint
          pageStyle={pageStyle}
          documentTitle={
            `Company Invoice of ` +
            props?.name +
            "- " +
            (props?.data?.invoiceNo || props?.data?.bookingInvoiceNo
              ? props?.data?.invoiceNo
                ? props?.data?.invoiceNo
                : props?.data?.bookingInvoiceNo
                ? props?.data?.bookingInvoiceNo
                : "--"
              : props.invoiceNo
              ? props.invoiceNo
              : "--")
          }
          trigger={() => <ButtonWithBG label="Print"></ButtonWithBG>}
          content={() => componentRef.current}
        /> */}
        <ButtonWithBG onClick={()=>handleDownloadPdf('download')} label="Download" />
        <ButtonWithBG onClick={()=>handleDownloadPdf('print')} label="Print" />

      </div>
    </>
  );
};

export default CompanyInvoiceDownloadView;
